import styled from "styled-components";
import { colors, variables } from "../../shared/styled/varibles";

export const MainSC = styled.main`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100vw;
    height: 100vh;
`;

export const HeaderSC = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: ${variables.headerHeight};
    border-bottom: 1px solid ${colors.stroke};
    width: 100%;
`;

export const SidebarSC = styled.div`
    display: flex;
    position: fixed;
    top: ${variables.headerHeight};
    left: 0;
    bottom: 0;
    width: ${variables.sideBarWidth};
`;

export const SectionSC = styled.section`
    display: flex;
    flex-direction: row;
    margin-left: ${variables.sideBarWidth};
    margin-top: ${variables.headerHeight};
`;
